import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Game, FootballGameTeamStatistic, Tournament } from '@mtgame/core';

@Component({
  selector: 'mtg-football-game-statistic',
  templateUrl: './football-game-statistic.component.html',
  styleUrls: ['./football-game-statistic.component.scss', '../../game/styles/statistic.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FootballGameStatisticComponent {
  @Input()
  game: Game;
  @Input()
  statistic: FootballGameTeamStatistic;
  @Input()
  teamRoute: string|string[];
  @Input()
  competitorTeamRoute: string|string[];
  @Input()
  tournament: Tournament;
}
